import { useState, useRef, useEffect, } from "react";
import styles from "../../styles/chatStyles";
import EmojiPicker from "emoji-picker-react";
import { db } from "../../firebase";
import { doc, setDoc } from "firebase/firestore";


export default function MessageInput({
  onSend,
  onFile,
  reply,
  setReply,
  chatId,   // ✅
  user,     // ✅
}) {
  const [text, setText] = useState("");
  const [showDice, setShowDice] = useState(false);
  const [showEmoji, setShowEmoji] = useState(false);
  const [recording, setRecording] = useState(false);
const typingTimeout = useRef(null);
  const diceRef = useRef(null);

  

  const mediaRecorderRef = useRef(null);
  const chunksRef = useRef([]);
  const pickerRef = useRef(null);
  const renderDiceIcon = (d) => {
  const common = {
    width: 22,
    height: 22,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "white",
    strokeWidth: 1.3,
  };

  switch (d) {
    case 4: // тетраэдр
      return (
        <svg {...common}>
          <polygon points="12,3 21,18 3,18" />
        </svg>
      );

    case 6: // куб
      return (
        <svg {...common}>
          <rect x="4" y="4" width="16" height="16" rx="3" />
        </svg>
      );

    case 8: // октаэдр (ромб)
      return (
        <svg {...common}>
          <polygon points="12,2 22,12 12,22 2,12" />
        </svg>
      );

    case 10: // d10 (чуть вытянутый)
      return (
        <svg {...common}>
          <polygon points="12,2 20,7 17,22 7,22 4,7" />
        </svg>
      );

    case 12: // d12 (почти круглый)
      return (
        <svg {...common}>
          <polygon points="12,2 18,4 22,10 20,18 12,22 4,18 2,10 6,4" />
        </svg>
      );

    case 20: // d20 (сложный)
      return (
        <svg {...common}>
          <polygon points="12,2 20,6 22,14 16,22 8,22 2,14 4,6" />
        </svg>
      );

    case 100: // d100 (условный)
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="9" />
        </svg>
      );

    default:
      return null;
  }
};

  useEffect(() => {
  const handleClick = (e) => {
    if (pickerRef.current && !pickerRef.current.contains(e.target)) {
      setShowEmoji(false);
    }

    if (diceRef.current && !diceRef.current.contains(e.target)) {
      setShowDice(false);
    }
  };

  document.addEventListener("mousedown", handleClick);
  return () => document.removeEventListener("mousedown", handleClick);
}, []);

  const send = () => {
    if (!text.trim()) return;
    onSend(text);
    setText("");
  };
        const handleTyping = async (value) => {
  setText(value);

  if (!chatId) return;

  let type = "text";

  // 🧠 если удаляет
  if (value.length < text.length) {
    type = "deleting";
  }

  // 🧠 если пусто — убираем статус
  if (value.length === 0) {
    type = null;
  }

  await setDoc(
    doc(db, "chats", chatId),
    {
      typing: type
        ? {
            user,
            type,
          }
        : null,
    },
    { merge: true }
  );

  clearTimeout(typingTimeout.current);

  typingTimeout.current = setTimeout(async () => {
    await setDoc(
      doc(db, "chats", chatId),
      {
        typing: null,
      },
      { merge: true }
    );
  }, 1200);
};

  // 🎤 ГОЛОС
  const startRecording = async () => {
    if (chatId) {
  await setDoc(doc(db, "chats", chatId), {
    typing: {
      user,
      type: "voice"
    }
  }, { merge: true });
}
    const stream = await navigator.mediaDevices.getUserMedia({
      audio: true,
    });

    const mediaRecorder = new MediaRecorder(stream);
    mediaRecorderRef.current = mediaRecorder;

    chunksRef.current = [];

    mediaRecorder.ondataavailable = (e) => {
      chunksRef.current.push(e.data);
    };

    mediaRecorder.onstop = () => {
      const blob = new Blob(chunksRef.current, {
        type: "audio/webm",
      });

      onFile(blob); // 🔥 используем ту же функцию
    };

    mediaRecorder.start();
    setRecording(true);
  };

  const stopRecording = async () => {
  mediaRecorderRef.current?.stop();
  setRecording(false);

  if (chatId) {
    await setDoc(doc(db, "chats", chatId), {
      typing: null
    }, { merge: true });
  }
};

  // 🎲 DICE
  const diceList = [4, 6, 8, 10, 12, 20, 100];

  const rollDice = (d) => {
  const result = Math.floor(Math.random() * d) + 1;

  onSend({
    type: "dice",
    dice: d,
    value: result,
  });

  setShowDice(false);
};

  // 🙂 EMOJI
  const emojis = ["😀", "😂", "🥲", "😍", "🔥", "💀", "😎", "😭"];

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        padding: 10,
        borderTop: "1px solid rgba(255,255,255,0.08)",
        background: "rgba(255,255,255,0.02)",
            position: "relative",
        backdropFilter: "blur(12px)",
      }}
    >
      {/* 🔁 REPLY */}
      {reply && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",

            marginBottom: 8,
            padding: "10px 12px",

            borderRadius: 14,
            borderLeft: "3px solid #4cff4c",

            background: "rgba(255,255,255,0.05)",
          }}
        >
          <div
            style={{
              overflow: "hidden",
              flex: 1,
            }}
          >
            <div style={{ fontSize: 12, opacity: 0.6 }}>
              Ответ {reply.sender}
            </div>

            <div
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                fontSize: 14,
              }}
            >
              {reply.text}
            </div>
          </div>

          <div
            onClick={() => setReply(null)}
            style={{
              marginLeft: 10,
              cursor: "pointer",
              opacity: 0.6,
            }}
          >
            ✕
          </div>
        </div>
      )}

      {/* 🎲 PANEL */}
      {/* 🎲 DICE POPUP */}
{showDice && (
  <div
      ref={diceRef}
    style={{
      position: "absolute",
      bottom: 70,
      left: 60, // чуть правее emoji
      zIndex: 10,

      display: "grid",
      gridTemplateColumns: "repeat(4, 1fr)",
      gap: 8,
      padding: 10,

      borderRadius: 16,
      background: "rgba(20,20,20,0.6)",
      backdropFilter: "blur(20px)",
      border: "1px solid rgba(255,255,255,0.08)",
      boxShadow: "0 10px 40px rgba(0,0,0,0.4)",

      transform: showDice ? "scale(1)" : "scale(0.95)",
      opacity: showDice ? 1 : 0,
      transition: "all 0.15s ease",
    }}
  >
    {diceList.map((d) => (
      <div
        key={d}
        onClick={() => rollDice(d)}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",

          padding: 8,
          borderRadius: 12,
          cursor: "pointer",

          background: "rgba(255,255,255,0.04)",
          border: "1px solid rgba(255,255,255,0.08)",

          transition: "0.15s",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = "rgba(255,255,255,0.1)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = "rgba(255,255,255,0.04)";
        }}
      >
        {renderDiceIcon(d)}
        <div style={{ fontSize: 11, opacity: 0.7, marginTop: 4 }}>
          d{d}
        </div>
      </div>
    ))}
  </div>
)}

      {/* 🙂 EMOJI PANEL */}
      {showEmoji && (
  <div
    ref={pickerRef} // 💣 ПЕРЕНЕСЛИ СЮДА
    style={{
        position: "absolute",
        bottom: 70,
        left: 10,
        zIndex: 10,

        borderRadius: 16,
        overflow: "hidden",

        background: "rgba(20,20,20,0.6)",
        backdropFilter: "blur(20px)",
        border: "1px solid rgba(255,255,255,0.08)",

        boxShadow: "0 10px 40px rgba(0,0,0,0.4)",

        transform: showEmoji ? "scale(1)" : "scale(0.95)",
        opacity: showEmoji ? 1 : 0,
        transition: "all 0.15s ease",
        }}
  >
    <EmojiPicker
  onEmojiClick={(emojiData) => {
    setText((prev) => prev + emojiData.emoji);
      setShowDice(false); 
  }}
  theme="dark"
  width={300}
  height={380}

  searchDisabled={false}
  skinTonesDisabled={true}
  previewConfig={{ showPreview: false }}

  // 💣 ВАЖНО
  className="glass-emoji"
/>
  </div>
)}

      {/* 🔥 MAIN INPUT ROW */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
        }}
      >
        {/* 🙂 */}
            <button onClick={() => setShowEmoji((p) => !p)}  style={styles.iconBtn}>
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="white" strokeWidth="1.5">
                <circle cx="12" cy="12" r="9" />
                <path d="M8 14s1.5 2 4 2 4-2 4-2" />
                <line x1="9" y1="9" x2="9.01" y2="9" />
                <line x1="15" y1="9" x2="15.01" y2="9" />
            </svg>
            </button>

        {/* 🎲 DICE */}
            <button onClick={() => setShowDice((p) => !p)} style={styles.iconBtn}>
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="white" strokeWidth="1.5">
                <rect x="4" y="4" width="16" height="16" rx="4" />
                <circle cx="9" cy="9" r="1" />
                <circle cx="15" cy="15" r="1" />
            </svg>
            </button>

        {/* 🎤 VOICE */}
            <button
            onMouseDown={startRecording}
            onMouseUp={stopRecording}
            style={{
                ...styles.iconBtn,
                border: recording ? "1px solid #fff" : "1px solid rgba(255,255,255,0.1)",
                background: recording ? "rgba(255,255,255,0.15)" : "rgba(255,255,255,0.05)",
            }}
            >
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="white" strokeWidth="1.5">
                <rect x="9" y="3" width="6" height="11" rx="3" />
                <path d="M5 11a7 7 0 0 0 14 0" />
                <line x1="12" y1="18" x2="12" y2="21" />
            </svg>
            </button>

       {/* 📎 FILE */}
            <input
            type="file"
            onChange={(e) => onFile(e.target.files[0])}
            style={{ display: "none" }}
            id="fileInput"
            />

            <label htmlFor="fileInput" style={styles.iconBtn}>
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="white" strokeWidth="1.5">
                <path d="M21 12.3l-9.4 9.4a6 6 0 0 1-8.5-8.5l9.4-9.4a4 4 0 1 1 5.7 5.7L9 19a2 2 0 1 1-2.8-2.8l8.5-8.5" />
            </svg>
            </label>

        {/* ✏️ INPUT */}
        <input
          value={text}
          onChange={(e) => handleTyping(e.target.value)}
          placeholder="Сообщение..."
          style={{
            ...styles.input,
            flex: 1,
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") send();
          }}
        />

        {/* ➤ */}
        <button onClick={send} style={styles.sendBtn}>
          ➤
        </button>
      </div>
    </div>
  );
}